"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _link = _interopRequireDefault(require("@clayui/link"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _DropDownContext = require("./DropDownContext");
var _excluded = ["active", "children", "className", "data-index", "disabled", "href", "innerRef", "onClick", "role", "roleItem", "spritemap", "style", "symbolLeft", "symbolRight", "tabIndex"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var Item = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    dataIndex = _ref['data-index'],
    disabled = _ref.disabled,
    href = _ref.href,
    innerRef = _ref.innerRef,
    _onClick = _ref.onClick,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'presentation' : _ref$role,
    _ref$roleItem = _ref.roleItem,
    roleItem = _ref$roleItem === void 0 ? 'menuitem' : _ref$roleItem,
    spritemap = _ref.spritemap,
    style = _ref.style,
    symbolLeft = _ref.symbolLeft,
    symbolRight = _ref.symbolRight,
    tabIndex = _ref.tabIndex,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var clickableElement = _onClick ? 'button' : 'span';
  var ItemElement = href ? _link.default : clickableElement;
  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
    close = _useContext.close,
    closeOnClick = _useContext.closeOnClick,
    tabFocus = _useContext.tabFocus;
  return /*#__PURE__*/_react.default.createElement("li", {
    "aria-selected": active,
    "data-index": dataIndex,
    ref: ref,
    role: role,
    style: style
  }, /*#__PURE__*/_react.default.createElement(ItemElement, _extends({}, otherProps, {
    className: (0, _classnames.default)('dropdown-item', className, {
      active: active,
      disabled: disabled
    }),
    disabled: disabled,
    href: href,
    onClick: function onClick(event) {
      if (_onClick) {
        _onClick(event);
      }
      if (event.defaultPrevented) {
        return;
      }
      if (closeOnClick) {
        close();
      }
    },
    ref: innerRef,
    role: roleItem,
    tabIndex: disabled || !tabFocus ? -1 : tabIndex
  }), symbolLeft && /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown-item-indicator-start"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: symbolLeft
  })), children, symbolRight && /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown-item-indicator-end"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: symbolRight
  }))));
});
Item.displayName = 'ClayDropDownItem';
var _default = exports.default = Item;